import { Col, Row } from 'antd'
import * as React from 'react'

import Element from './Element'

const CardElements: React.FC = () => {
  return (
    <Row gutter={[0, 12]}>
      <Col span={24}>
        <Element type="cardNumber" />
      </Col>
      <Col span={12}>
        <Element type="cardExpiry" />
      </Col>
      <Col span={12}>
        <Element type="cardCvc" />
      </Col>
    </Row>
  )
}

export default CardElements
